import { createRequestTypes, createActions } from "../../global/utilities";

export const PREVIEW_SCAN = createRequestTypes("PREVIEW_SCAN");

export const previewScanRequest = () => createActions(PREVIEW_SCAN["REQUEST"]);
export const previewScanSuccess = data =>
  createActions(PREVIEW_SCAN["SUCCESS"], { data });
export const previewScanError = error =>
  createActions(PREVIEW_SCAN["ERROR"], { error });
